import React from 'react';

import CancelIcon from '@mui/icons-material/Cancel';
import { Control } from 'react-hook-form';
import { IconButton, LbInput } from '@infoods/lifebase-ui';

import classes from './EditPrizeRow.module.scss';
import { FormFieldsGrid } from '../../FormFieldsGrid/FormFieldsGrid';
import { ChallengeFormValues } from '../../../../interfaces/ChallengeFormValues';
import {
  validateWhitespace,
  validateRichTextWhitespace,
} from '../../../../../shared/utils/reactHookFormUtils';
import { RichTextEditor } from '../../../../../shared/features/rich-text';

type EditPrizeRowProps = {
  index: number;
  control: Control<ChallengeFormValues>;
  onRemove: (index: number) => void;
  showRemoveButton: boolean;
};

export const EditPrizeRow = ({
  index,
  control,
  onRemove,
  showRemoveButton,
}: EditPrizeRowProps) => {
  const generalInputProps = {
    control,
    variant: 'standard',
    size: 'small',
  } as const;

  return (
    <FormFieldsGrid>
      <div className={classes.prizeLabel}>Prize {index + 1}</div>
      <div className={classes.fieldColumns}>
        <div className={classes.inputBox}>
          <LbInput
            {...generalInputProps}
            name={`prizes.prizes.${index}.title`}
            label="Title"
            rules={{ required: 'Title is required', validate: { validateWhitespace } }}
          />
          <RichTextEditor
            {...generalInputProps}
            name={`prizes.prizes.${index}.description`}
            label="Description"
            rules={{
              required: 'Description is required',
              validate: { validateRichTextWhitespace },
            }}
          />
        </div>
        {showRemoveButton && (
          <IconButton
            onClick={() => onRemove(index)}
            color="tertiary"
            aria-label={`Remove prize ${index + 1}`}
          >
            <CancelIcon />
          </IconButton>
        )}
      </div>
    </FormFieldsGrid>
  );
};
